'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reduxForm = require('redux-form');

var _components = require('components');

var _applicationForm = require('redux/modules/applicationForm');

var applicationFormActions = _interopRequireWildcard(_applicationForm);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _Content = require('./../../helpers/Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrainingGroup = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { initialize: _reduxForm.initialize }), _dec2 = (0, _reactRedux.connect)(function () {
  return {};
}, function (dispatch, ownProps) {
  var mappedProps = (0, _redux.bindActionCreators)(applicationFormActions, dispatch);
  mappedProps.params = ownProps.params;
  return mappedProps;
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(TrainingGroup, _Component);

  function TrainingGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TrainingGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TrainingGroup.__proto__ || (0, _getPrototypeOf2.default)(TrainingGroup)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (data) {
      _this.props.saveApplicationForm(data).then(function () {
        _this.props.hideForm();
      }).catch(function (err) {
        window.alert('Je nám líto, ale někde se stala chyba :( Zkuste to prosím ještě jednou nebo napište na info@nenudimse.cz. ' + (0, _stringify2.default)(err));
      });
    }, _this.handleRepeat = function () {
      _this.props.showForm();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TrainingGroup, [{
    key: 'render',
    value: function render() {
      var styles = require('./TrainingGroup.scss');
      var styles2 = require('./../TrainingGroups/TrainingGroups.scss');
      var photoIntro = require('./../TrainingGroups/training-groups-intro.jpg');
      var filip = require('./filip-zettl.jpg');
      var preFilled = {
        type: 'training-group'
      };

      var variantParam = this.props.params.variant;
      var pageParams = {
        heading: 'Sportovní přípravka'
      };

      if (typeof variantParam !== 'undefined') {
        switch (variantParam) {
          case 'v-rybnickach-praha-10':
            preFilled.variant = preFilled.type + '-v-rybnickach-praha-10-2019';
            pageParams.date = 'Pondělí a středa od 15:30 do 16:30';
            pageParams.content = 'Je vaše dítě ve věku mezi 6 a 13 lety a chtělo by sportovat? Pokud ano, těšíme se na něj v naší sportovní přípravce na Praze 10. Tréninky probíhají na hřišti ZŠ V Rybníčkách <strong>každé pondělí a středu od 15:30</strong>. V zimních měsících se s dětmi přesuneme do tělocvičny ZŠ Olešská.<br />Cena na celý školní rok je <strong>5&nbsp;000</strong> Kč.';
            pageParams.lat = 49.138722;
            pageParams.lng = 13.68832;
            pageParams.price = '5&nbsp;000';
            break;

          case 'jakutska-praha-10':
            preFilled.variant = preFilled.type + '-jakutska-praha-10-2019';
            pageParams.date = 'Úterý a čtvrtek od 16:00';
            pageParams.content = 'Je vaše dítě ve věku mezi 4 a 13 lety a chtělo by sportovat? Pokud ano, těšíme se na něj v naší sportovní přípravce na Praze 10. Tréninky probíhají na hřišti gymnázia Omská <strong>každé úterý a čtvrtek od 16:00</strong>. V zimních měsících se s dětmi přesuneme do tělocvičny.<br />Cena na celý školní rok je <strong>5&nbsp;000</strong> Kč.';
            pageParams.lat = 50.767193;
            pageParams.lng = 15.184950;
            pageParams.price = '5&nbsp;000';
            break;

          case 'omska-praha-10':
            preFilled.variant = preFilled.type + '-omska-praha-10-2022';
            pageParams.date = 'Úterý od 16:15 a čtvrtek od 17:00';
            pageParams.content = 'Je vaše dítě ve věku mezi 4 a 13 lety a chtělo by sportovat? Pokud ano, těšíme se na něj v naší sportovní přípravce na Praze 10. Tréninky probíhají na hřišti gymnázia Omská <strong>každé úterý od 16:15 a čtvrtek od 17:00</strong>. V zimních měsících se s dětmi přesuneme do tělocvičny.<br />Cena na celý školní rok je <strong>5&nbsp;000</strong> Kč.';
            pageParams.lat = 50.767193;
            pageParams.lng = 15.184950;
            pageParams.price = '5&nbsp;000';
            break;

          case 'na-beranku-praha-4':
            preFilled.variant = preFilled.type + '-na-beranku-praha-4-2019';
            pageParams.date = 'Pondělí a čtvrtek od 15:00 do 16:00';
            pageParams.content = 'Je vaše dítě ve věku mezi 6 a 13 lety a chtělo by sportovat? Pokud ano, těšíme se na něj v naší sportovní přípravce na Praze 4. Tréninky probíhají na hřišti ZŠ Na Beránku <strong>každé pondělí a čtvrtek od 15:00</strong>. V zimních měsících se s dětmi přesuneme do tělocvičny.<br />Cena na celý školní rok je <strong>5&nbsp;000</strong> Kč.';
            pageParams.lat = 50.767193;
            pageParams.lng = 15.184950;
            pageParams.price = '5&nbsp;000';
            break;

          case 'zs-bitovska-praha-4':
            preFilled.variant = preFilled.type + '-zs-bitovska-praha-4-2023';
            pageParams.date = 'Středa od 15:00 do 16:00';
            pageParams.content = 'Je vaše dítě ve věku mezi 6 a 13 lety a chtělo by sportovat? Pokud ano, těšíme se na něj na kroužku míčových her, atletiky a gymnastiky na Praze 4. Tréninky probíhají na ZŠ Bítovská <strong>každou středu od 15:00</strong>. V zimních měsících se s dětmi přesuneme do tělocvičny.<br />Cena na pololetí je <strong>2&nbsp;000</strong> Kč.';
            pageParams.lat = 50.767193;
            pageParams.lng = 15.184950;
            pageParams.price = '2&nbsp;000';
            break;

          case 'na-lise-praha-4':
            preFilled.variant = preFilled.type + '-na-lise-praha-4-2019';
            pageParams.date = 'Úterý a čtvrtek od 17:00 do 18:00';
            pageParams.content = 'Je vaše dítě ve věku mezi 6 a 13 lety a chtělo by sportovat? Pokud ano, těšíme se na něj v naší sportovní přípravce na Praze 4. Tréninky probíhají na hřišti ZŠ Na Líše <strong>každé úterý a čtvrtek od 17:00</strong>. V zimních měsících se s dětmi přesuneme do tělocvičny. Po dohodě může trenér vyzvednout děti ze školní družiny.<br />Cena na pololetí je <strong>2&nbsp;000</strong>&nbsp;Kč (trénink 2x týdně) nebo 1&nbsp;500&nbsp;Kč (trénink 1x týdně).';
            pageParams.lat = 50.767193;
            pageParams.lng = 15.184950;
            pageParams.price = '5&nbsp;000';
            break;

          default:
            break;
        }
      }

      var data = {
        intro: {
          text: pageParams.content,
          image: {
            src: photoIntro,
            alt: 'Sportovní přípravka pro všechny'
          }
        }
      };

      this.props.initialize('application-form', preFilled);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: pageParams.heading + '. ' + pageParams.date,
          meta: [{
            name: 'description',
            content: pageParams.heading + '. ' + pageParams.date
          }, {
            property: 'og:description',
            content: pageParams.heading + '. ' + pageParams.date
          }, {
            property: 'og:title',
            content: pageParams.heading + '. ' + pageParams.date
          }, {
            name: 'keywords',
            content: 'sportovní přípravka pro děti'
          }],
          link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz/sportovni-pripravka/' + variantParam }] }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'h1',
            null,
            pageParams.heading,
            ' ',
            _react2.default.createElement(
              'small',
              null,
              pageParams.date
            )
          )
        ),
        _Content2.default.renderIntro(styles2, data.intro),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid darker-container' },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            preFilled.variant === 'training-group-jakutska' && _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('row', styles.person) },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-4 col-xs-offset-4 col-sm-2 col-sm-offset-0' },
                  _react2.default.createElement('img', { width: '100%', src: filip })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12 col-sm-10' },
                  _react2.default.createElement(
                    'h2',
                    null,
                    'Filip Zettl ',
                    _react2.default.createElement(
                      'small',
                      null,
                      'tren\xE9r skupiny'
                    )
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Filip absolvoval sportovn\xED z\xE1kladn\xED \u0161kolu Jeseniova, kterou reprezentoval na atletick\xFDch z\xE1vodech. V sou\u010Dasn\xE9 dob\u011B studuje zdravotnickou \u0161kolu. M\xE1 za sebou n\u011Bkolikaletou zku\u0161enost s tr\xE9nov\xE1n\xEDm mal\xFDch d\u011Bt\xED. V Nenud\xEDm se vede 2 tr\xE9ninkov\xE9 skupiny a b\u011Bhem ly\u017Ea\u0159sk\xFDch kurz\u016F exceluje jako instruktor ly\u017Eov\xE1n\xED. R\xE1d si zahraje florbal, volejbal a jeho kon\xED\u010Dkem je v\xFDchova mal\xE9ho J\xE1chyma.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12', styles.shortApplicationForm) },
              _react2.default.createElement(
                'h2',
                { className: styles.applicationHeading },
                'P\u0159ihl\xE1\u0161ka'
              ),
              (preFilled.variant === 'training-group-omska-praha-10-2022' || preFilled.variant === 'training-group-zs-bitovska-praha-4-2023') && _react2.default.createElement(_components.ApplicationForm, { onSubmit: this.handleSubmit, repeat: this.handleRepeat, preFilled: preFilled }),
              preFilled.variant !== 'training-group-omska-praha-10-2022' && preFilled.variant !== 'training-group-zs-bitovska-praha-4-2023' && _react2.default.createElement(
                'p',
                null,
                preFilled.variant,
                ' Je n\xE1m l\xEDto, ale tato skupina je pln\xE1. ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/sportovni-pripravka', title: 'Sportovn\xED p\u0159\xEDpravka' },
                  'Vyberte si pros\xEDm jin\xFD term\xEDn sportovn\xED p\u0159\xEDpravky'
                ),
                '.'
              )
            )
          )
        )
      );
    }
  }]);
  return TrainingGroup;
}(_react.Component), _class2.propTypes = {
  initialize: _react.PropTypes.func.isRequired,
  params: _react.PropTypes.object.isRequired,
  saveApplicationForm: _react.PropTypes.func.isRequired,
  showForm: _react.PropTypes.func.isRequired,
  hideForm: _react.PropTypes.func.isRequired
}, _temp2)) || _class) || _class);
exports.default = TrainingGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TrainingGroup/TrainingGroup.js
// module id = 1116
// module chunks = 0